<script setup lang='ts'>
import { ref } from 'vue'
import Dialog from 'primevue/dialog'
import { router } from '@inertiajs/vue3'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimes, faExclamationTriangle } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'
import { routeType } from '@/types/route'
import Button from '@/Components/Utils/Button.vue';
library.add(faTimes, faExclamationTriangle)

const props = defineProps<{
    title?: string
    description?: string
    icon?: any
    yesLabel?: string
    yesIcon?: string
    noLabel?: string
    routeDelete?: routeType
    isFullLoading?: boolean
    preserveScroll?: boolean
}>()

const emits = defineEmits<{
    (e: 'onNo'): void
    (e: 'onYes'): void
    (e: 'onSuccess'): void
}>()

const isOpenModal = ref(false)
const isLoadingdelete = ref(false)
const onClickDelete = () => {
    if (!props.routeDelete?.name) return

    const routeMethod = props.routeDelete.method || 'delete'

    if (props.routeDelete?.method === 'delete') {
        router.delete(
            route(props.routeDelete.name, props.routeDelete.parameters),
            {
                preserveScroll: props.preserveScroll,
                onStart: () => {
                    isLoadingdelete.value = true
                },
                onSuccess: () => {
                    isOpenModal.value = false
                    emits('onSuccess')
                },
                onFinish: () => {
                    if (props.isFullLoading) {

                    } else {
                        isLoadingdelete.value = false
                    }
                }
            }
        )
    } else {
        router[routeMethod](
            route(props.routeDelete.name, props.routeDelete.parameters),
            {},
            {
                onStart: () => {
                    isLoadingdelete.value = true
                },
                onSuccess: () => {
                    isOpenModal.value = false
                    emits('onSuccess')
                },
                onFinish: () => {
                    if (props.isFullLoading) {

                    } else {
                        isLoadingdelete.value = false
                    }
                }
            }
        )
    }
    
}
</script>

<template>
    <div>

        <slot name="default" :isOpenModal :changeModel="() => isOpenModal = !isOpenModal" :isLoadingdelete>

        </slot>

        <Dialog
            v-model:visible="isOpenModal"
            modal
            dismissableMask
            :showHeader="false"
            :style="{ width: '32rem' }"
            :breakpoints="{ '640px': '90vw' }"
        >
            <div class="relative pt-5">
                <div class="absolute top-0 right-0 hidden pt-4 sm:block">
                    <button type="button"
                        class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                        @click="isOpenModal = false">
                        <span class="sr-only">Close</span>
                        <FontAwesomeIcon :icon='icon || "fal fa-times"' class='' fixed-width aria-hidden='true' />
                    </button>
                </div>
                <div class="sm:flex sm:items-start">
                    <div
                        class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                        <FontAwesomeIcon icon='fal fa-exclamation-triangle' class='text-red-600' fixed-width aria-hidden='true' />
                    </div>
                    <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 class="text-base font-semibold">
                            {{ title || "Yakin ingin menghapus data ini?" }}
                        </h3>
                        <div class="mt-2">
                            <p class="text-sm text-gray-500">
                                {{ description || "Data akan dihapus dan mungkin berakibat data di tempat lain memiliki nilai kosong."}}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="mt-5 sm:mt-4 flex flex-row-reverse gap-x-2">
                    <Button
                        @click="() => (onClickDelete(), emits('onYes'))"
                        :loading="isLoadingdelete"
                        type="red"
                        :label="yesLabel ?? 'Hapus'"
                        :icon="yesIcon ?? 'far fa-trash-alt'"
                        full
                    />

                    <Button
                        type="tertiary"
                        icon="far fa-arrow-left"
                        label="Batal"
                        @click="() => (isOpenModal = false, emits('onNo'))"
                    />
                </div>
            </div>
        </Dialog>
    </div>
</template>